<template>
  <div :disabled="true" id="page-content" tabindex="-1">
    <span
      aria-label="Select Service Page"
      aria-live="polite"
      role="contentinfo"
    ></span>
    <h2
      class="public-h5 font-weight-bold mt-5 mb-5"
      :class="isRTLLanguage ? 'rtl' : 'normal'"
    >
      {{ siteText.ui.selectServicePageHeader }}
    </h2>
    <v-card>
      <v-card-text class="centerContainer">
        <div v-if="displaySelectedService">
          <p :class="isRTLLanguage ? 'rtl' : 'normal'">
            <span
              ><strong> {{ siteText.ui.serviceSelectedService }} </strong></span
            >{{ selectedService1.Name }}
            <span v-if="displaySelectedService2"
              >, &nbsp; {{ selectedService2.Name }}
            </span>
          </p>
          <p :class="isRTLLanguage ? 'rtl' : 'normal'">
            {{ selectedService1.AdditionalInfoText }}
            <a target="_blank" :href="selectedService1.Url">{{
              selectedService1.UrlText
            }}</a>
          </p>
        </div>
        <div
          v-if="displaySelectedService2"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          <!-- <p>{{ selectedService2.Name  }}</p> -->
          <p>
            {{ selectedService2.AdditionalInfoText }}
            <a target="_blank" :href="selectedService2.Url"
              >{{ selectedService2.UrlText }}.</a
            >
          </p>
        </div>
        
        <!-- REAL ID Upgrade Message -->
        <div 
          v-if="showRealIdMessage" 
          class="real-id-message mt-4 mb-4"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          <p v-html="siteText.ui.realIdUpgradeMessage"></p>
          <v-row class="mt-3">
            <v-col cols="6">
              <img 
                src="@/assets/images/Star_Sign_State_License.png" 
                alt="License with star example"
                class="example-image"
              />
            </v-col>
            <v-col cols="6">
              <img 
                src="@/assets/images/Flag_Sign_State_License.png" 
                alt="License with flag example"
                class="example-image"
              />
            </v-col>
          </v-row>
        </div>
        <opus-select-only-drop-down
          :disabled="disabledServiceType"
          :aria-disabled="disabledServiceType"
          :items="serviceTypes"
          select-name="serviceTypesSelect"
          item-label="CategoryDescription"
          item-id="CategoryId"
          :place-holder="siteText.ui.serviceTypeDropdownList"
          :label="siteText.ui.serviceCategory"
          @item:selected="serviceTypeChange"
          v-model="serviceType"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
        </opus-select-only-drop-down>
        <p>&nbsp;</p>
        <opus-select-only-drop-down
          :disabled="disabledService"
          :aria-disabled="disabledService"
          :items="services"
          select-name="servicesSelect"
          item-label="Name"
          :place-holder="siteText.ui.serviceDropdownList"
          :label="siteText.ui.service"
          @item:selected="serviceChange"
          v-model="service"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
        </opus-select-only-drop-down>
        <p></p>
        <!-- ET 723 Remove option to book a "Combo" appointment from public facing website -->
        <!-- <p
          v-if="displaySelectAnotherService"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          <a
            href="#"
            class="text-decoration-underline"
            @click="selectAnotherService()"
          >
            {{ siteText.ui.serviceSelectAnotherService }}
          </a>
        </p> -->
        <p
          v-if="displayRemoveServices"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          <a
            href="#"
            class="text-decoration-underline"
            @click="removeServices()"
          >
            {{ siteText.ui.serviceRemoveServices }}
          </a>
        </p>
        <!-- <p v-if="servicesRemoved" 
        :class="isRTLLanguage ? 'rtl' : 'normal'">
          <strong>{{ siteText.ui.serviceServicesRemovedMessage }}</strong>
        </p> -->
        <span
          role="alert"
          aria-live="assertive"
          :aria-label="siteText.ui.serviceServicesRemovedMessage"
          :aria-hidden="!servicesRemoved"
        >
        </span>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-md-4">
      <!-- Desktop Layout -->
      <v-layout row wrap class="hidden-sm-and-down">
        <v-flex md3>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="280px"
            @click="back()"
            ><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.serviceBack }}
          </v-btn>
        </v-flex>
        <v-flex md3>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="280px"
            :disabled="disabledContinue"
            :aria-disabled="disabledContinue"
            @click="serviceContinue()"
          >
            {{ siteText.ui.serviceContinue }}
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- Mobile Layout -->
      <v-layout row wrap class="hidden-md-and-up">
        <v-flex xs12> </v-flex>
        <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          :disabled="disabledContinue"
          :aria-disabled="disabledContinue"
          @click="serviceContinue()"
        >
          {{ siteText.ui.serviceContinue }}
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        <v-flex xs12>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="back()"
            ><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.serviceBack }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OpusSelectOnlyDropDown from "@/components/OpusSelectOnlyDropDown.vue";

export default {
  name: "SelectServicePage",
  data: () => ({
    serviceType: "",
    serviceTypes: [],
    selectedServiceType1: "",
    services: [],
    service: "",
    disabledServiceType: false,
    disabledService: true,
    displaySelectedService: false,
    displaySelectAnotherService: false,
    numberOfServices: 0,
    displaySelectedService2: false,
    disabledContinue: true,
    selectedService1: "",
    selectedService2: "",
    displayRemoveServices: false,
    servicesRemoved: false,
  }),
  components: {
    OpusSelectOnlyDropDown,
  },
  methods: {
    ...mapActions("selectedService", {
      numberOfServicesAction: "numberOfServices",
      selectService1: "selectService1",
      selectService2: "selectService2",
      selectedServiceType1Action: "selectedServiceType1",
      clearSelectedServices: "clearSelectedServices",
    }),
    ...mapActions({
      navFromSelectServicePageAction: "navFromSelectServicePage",
    }),
    ...mapActions(["setAvailableLocationsByCounty", "dateOfBirth"]),
    nextPage(page) {
      this.$emit("navigateTo", page);
    },
    back() {
      this.navFromSelectServicePageAction({ value: true });
      this.numberOfServicesAction({ value: this.numberOfServices });
      this.selectService1(this.selectedService1);
      this.selectedServiceType1Action(this.selectedServiceType1);
      if (this.numberOfServices === 2) {
        this.selectService2(this.selectedService2);
      }
      this.$emit("navigateTo", "NewReservationPage", {
        pageName: "Schedule a Reservation",
      });
    },
    serviceContinue() {
      console.log("serviceContinue");
      this.numberOfServicesAction({ value: this.numberOfServices });
      this.selectService1(this.selectedService1);
      this.selectedServiceType1Action(this.selectedServiceType1);
      if (this.numberOfServices === 2) {
        this.selectService2(this.selectedService2);
      }
      if (
        this.selectedService1.MinimumAge ||
        this.selectedService2.MinimumAge
      ) {
        console.log("navigateTo DateOfBirthPage");
        this.$emit("navigateTo", "DateOfBirthPage", {
          pageName: "Date of Birth",
        });
      } else {
        this.dateOfBirth(null);
        this.$emit("navigateTo", "SelectLocationCountyPage", {
          pageName: "Select DMV Office Location",
        });
      }
    },
    serviceTypeChange() {
      console.log(this.serviceType);
      this.disabledService = false;
      this.servicesRemoved = false;
      for (
        let serviceTypeIndex = 0;
        serviceTypeIndex < this.serviceTypes.length;
        serviceTypeIndex += 1
      ) {
        if (
          this.serviceTypes[serviceTypeIndex].CategoryId ===
          this.serviceType.CategoryId
        ) {
          this.services = this.serviceTypes[serviceTypeIndex].ServiceTypes;
          console.log(this.services);
          break;
        }
      }
      if (
        this.numberOfServices === 1 &&
        this.serviceType.CategoryId === this.selectedServiceType1.CategoryId
      ) {
        this.services = this.services.filter(this.filterServices);
        console.log(this.services);
      }
    },
    filterServices(service) {
      return service.TypeId !== this.selectedService1.TypeId;
    },
    serviceChange() {
      console.log(this.service);
      this.disabledServiceType = true;
      this.disabledService = true;
      this.displaySelectedService = true;
      this.disabledContinue = false;
      this.displayRemoveServices = true;
      if (this.numberOfServices === 0) {
        this.displaySelectAnotherService = true;
        this.selectedServiceType1 = this.serviceType;
        this.selectedService1 = this.service;
        this.numberOfServices = 1;
      } else if (this.numberOfServices === 1) {
        this.displaySelectAnotherService = false;
        this.displaySelectedService2 = true;
        this.selectedService2 = this.service;
        this.numberOfServices = 2;
      }
    },
    selectAnotherService() {
      this.service = "";
      this.serviceType = "";
      this.disabledServiceType = false;
      this.displaySelectAnotherService = false;
      this.disabledContinue = true;
      // this.displayRemoveServices = false;
      // this.$refs["refService"].blur();
    },
    removeServices() {
      this.service = "";
      this.serviceType = "";
      this.disabledServiceType = false;
      this.displaySelectAnotherService = false;
      this.disabledContinue = true;
      this.displayRemoveServices = false;
      this.displaySelectedService = false;
      this.displaySelectedService2 = false;
      this.numberOfServices = 0;
      this.serviceTypes = this.serviceTypesGetter;
      this.clearSelectedServices();
      this.selectedService1 = "";
      this.selectedService2 = "";
      this.servicesRemoved = true;
      // this.$refs["refServiceType"].blur();
    },
  },
  computed: {
    ...mapGetters(["siteText", "isRTLLanguage"]),
    ...mapGetters({ serviceTypesGetter: "serviceTypes" }),
    ...mapGetters("selectedService", {
      numberOfServicesGetter: "numberOfServices",
      selectedService1Getter: "selectedService1",
      selectedService2Getter: "selectedService2",
      selectedServiceType1Getter: "selectedServiceType1",
    }),
    showRealIdMessage() {
      const REAL_ID_TYPE_ID = 204;
      return this.displaySelectedService && this.selectedService1?.TypeId === REAL_ID_TYPE_ID;
    }
  },
  mounted() {
    this.serviceTypes = this.serviceTypesGetter;
    this.numberOfServices = this.numberOfServicesGetter;
    this.selectedService1 = this.selectedService1Getter;
    this.selectedService2 = this.selectedService2Getter;
    this.selectedServiceType1 = this.selectedServiceType1Getter;
    this.setAvailableLocationsByCounty([]);
    if (typeof this.numberOfServices === "undefined") {
      this.numberOfServices = 0;
    }
    if (this.numberOfServices !== 0) {
      this.disabledServiceType = true;
      this.disabledService = true;
      this.disabledContinue = false;
      this.displayRemoveServices = true;
    }
    if (this.numberOfServices === 1) {
      this.displaySelectedService = true;
      this.displaySelectAnotherService = true;
    } else if (this.numberOfServices === 2) {
      this.displaySelectedService = true;
      this.displaySelectedService2 = true;
    }

    // common.updateSelectAriaLabel(
    //   this.$refs.serviceCategorySelect,
    //   "Select a service category"
    // );
    // common.updateSelectAriaLabel(this.$refs.serviceSelect, "Select a service");
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}

.accessibility {
  font-weight: 1000;
}

.real-id-message {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.example-image {
  width: 100%;
  max-width: 100%;
  height: auto;
}
</style>
